import script from "./AddRoleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddRoleModal.vue?vue&type=script&setup=true&lang=js"

import "./AddRoleModal.vue?vue&type=style&index=0&id=f6a296d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6a296d0"]])

export default __exports__